export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/lead_generation.dc89b09.svg";